// extracted by mini-css-extract-plugin
module.exports = {"root":"ClickableProgress_root__1bWgT","disabled":"ClickableProgress_disabled__1Atn2"};